export type Workout = {
  id: number;
  name: string;
};

export const WORKOUT_SECONDS = 30;
export const REST_SECONDS = 10;

export const workouts: Workout[] = [
  { id: 1, name: 'Jumping jacks' },
  { id: 2, name: 'Wall sit' },
  { id: 3, name: 'Push-up' },
  { id: 4, name: 'Abdominal crunch' },
  { id: 5, name: 'Step-up onto chair' },
  { id: 6, name: 'Squat' },
  { id: 7, name: 'Triceps dip on chair' },
  { id: 8, name: 'Plank' },
  { id: 9, name: 'High knees running in place' },
  { id: 10, name: 'Lunge' },
  { id: 11, name: 'Push-up and rotation' },
  { id: 12, name: 'Side plank' },
];
